import { produce } from "immer";
import * as Actions from "./savedSearchActions";

const initialState = {
  isLoading: false,
  errorMessage: null,
  totalCount: 0,
  currentPage: 1,
  isListOpen: false,
  isAddOpen: false,
  searchParams: null
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.OPEN_LIST: {
      draft.isListOpen = true;
      draft.errorMessage = null;
      break;
    }

    case Actions.CLOSE_LIST: {
      draft.isListOpen = false;
      break;
    }

    case Actions.SET_TOTAL: {
      draft.totalCount = action.payload;
      break;
    }

    case Actions.OPEN_ADD: {
      draft.isAddOpen = true;
      draft.errorMessage = null;
      break;
    }

    case Actions.CLOSE_ADD: {
      draft.isAddOpen = false;
      break;
    }

    case Actions.ADD_SAVED_SEARCH:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.ADD_SAVED_SEARCH_SUCCESS:
      draft.isLoading = false;
      draft.isAddOpen = false;
      break;

    case Actions.ADD_SAVED_SEARCH_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.DELETE_SAVED_SEARCH:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.DELETE_SAVED_SEARCH_SUCCESS:
      draft.isLoading = false;
      break;

    case Actions.DELETE_SAVED_SEARCH_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.FETCH_SAVED_SEARCH:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.FETCH_SAVED_SEARCH_SUCCESS:
      draft.isLoading = false;
      draft.isListOpen = false;
      break;

    case Actions.FETCH_SAVED_SEARCH_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.SET_SEARCH_PARAMS:
      draft.searchParams = action.payload.searchParams;
      break;

    case Actions.SET_PAGE: {
      draft.currentPage = action.payload.page;
      break;
    }

    case Actions.RESET_FAILED:
      draft.errorMessage = null;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
